// Rejects if the request has not settled in time, so a hung call surfaces as an accessible
// error instead of leaving the applicant on an indefinite spinner. There is no automatic
// retry: these writes are user-initiated and fail-closed, so a silent retry could double-write
// or multiply vendor form sessions.
export default function withTimeout(promise, timeoutMs) {
  let timer;
  const timeout = new Promise((resolve, reject) => {
    timer = setTimeout(() => {
      // Tagged so callers can tell a hung call apart from an outright failure. applicationActions
      // reads this to report errorKind 'timeout' rather than 'explicit'; without the tag the two
      // collapse into one RUM bucket and a hang becomes indistinguishable from an HTTP error.
      const error = new Error('The request timed out.');
      error.isTimeout = true;
      reject(error);
    }, timeoutMs);
  });
  const clear = (value) => {
    clearTimeout(timer);
    return value;
  };
  return Promise.race([promise, timeout])
    .then(clear, (error) => {
      clear();
      return Promise.reject(error);
    });
}
